<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>預算分配</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>預算分配</span></li>
          <li><span>(生活助學金)已用預算</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">(生活助學金)已用預算</h2>
            </header>
            <div class="panel-body">
              <div align="left">　
                類　　型：<span style="color:#0000CC;">生活 </span>
              </div>
              <div align="left">　
                單位名稱：<span style="color:#FF0000;">{{deptName}} </span>
              </div>
              <div align="left">　
                本薪總支出：<span style="color:#FF0000;">{{usedSalary | numberWithCommas}} </span>　
              </div>
              <div align="left">　
                本薪剩餘預算：<span style="color:#FF0000;">{{remainingBudgetSalary | numberWithCommas}} </span>　
              </div><br>
              <div class="s_tenr">
                <table class="table table-no-more table-bordered table-striped mb-none">
                  <thead>
                    <tr>
                      <th class="text-center" width="6%">學年度</th>
                      <th class="text-center" width="6%">年/月</th>
                      <th class="text-center" width="20%">生活助學金(本薪)-上學期</th>
                      <th class="text-center" width="20%">生活助學金(本薪)-下學期</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index">
                      <td data-title="學年度" class="text-center">{{schYear}}</td>
                      <td data-title="年/月" class="text-center">{{item.yearMonth}}</td>
                      <td data-title="生活助學金(本薪)-上學期" class="text-center">{{item.bursary1 | numberWithCommas}}</td>
                      <td data-title="生活助學金(本薪)-下學期" class="text-center">{{item.bursary2 | numberWithCommas}}</td>
                    </tr>
                  </tbody>
                </table>
                <div align="center">
                  <br><a href="#" @click.prevent="routerBack" class="btn-upload btn btn-primary" style="background-color:#9e9e9e; border-color:#858484;">返回</a>
                </div>
              </div>
            </div>
          </section>
          
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      deptName: null,
      schYear: null,
      usedSalary: 0,
      remainingBudgetSalary: 0,
      list: []
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.$http.get("/api/budget/used-budget-study/" + this.id).then(a => {
      let item = a.body;
      this.deptName = item.deptName;
      this.schYear = item.schYear;
      this.usedSalary = item.usedSalary;
      this.remainingBudgetSalary = item.remainingBudgetSalary;
      this.list = item.usedBudgetList;
    });
  },
  methods: {
    routerBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
</style>